import {Avatar, styled} from '@mui/material';

const BeneficiaryAvatar = styled(Avatar)`
	background-color: ${({theme}) => theme.palette.primary.dark};
	color: ${({theme}) => theme.palette.primary.contrastText};
`;

export {BeneficiaryAvatar};
